<template>
  <v-card>
    <vue-card-title
      :title="'Notes Templates'"
      :subtitle="'Refer to the following information for note templates.'"
      :icon="$getIcon('mdiClipboardTextOutline')"
    >
      <template slot="actions">
        <v-btn
          v-if="fetched"
          class="indigo accent-2 white--text text-capitalize my-0"
          small
          @click="notesTemplateForm = true"
        >
          Create Notes Template
        </v-btn>
      </template>
    </vue-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row v-if="!fetched">
        <v-col md="12" cols="12">
          <vue-default-svg-loader></vue-default-svg-loader>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col md="12" cols="12">
          <vue-pagination-component
            :fetch-api.sync="fetchAPI"
            :search-label="searchLabel"
            :query-params.sync="queryParams"
            :filter-query="queryParams"
            :next-link="nextLink"
            :previous-link="previousLink"
            :pagination-info="paginationInfo"
          ></vue-pagination-component>
        </v-col>
        <v-col v-if="fetchedData.length < 1 && filtered" md="12" cols="12">
          Search results not found.
        </v-col>
        <v-col v-else-if="fetchedData.length < 1" md="12" cols="12">
          <vue-no-data></vue-no-data>
        </v-col>
        <v-col
          v-for="(template, notesTemplateIndex) in fetchedData"
          v-else
          :key="notesTemplateIndex"
          md="3"
          cols="12"
        >
          <v-card>
            <v-card-title class="amber lighten-3 pa-2">
              <small>{{ template.title }}</small>
            </v-card-title>
            <v-card-text class="pa-0">
              <div id="wusiwug-viewer" class="scrollbar-sm">
                <div
                  disabled
                  rows="12"
                  class="yellow lighten-3 pa-2 scrollbar scrollbarOverview notes"
                  v-html="$sanitize(template.template)"
                ></div>
              </div>
            </v-card-text>
          </v-card>
          <a
            class="font-0 grey--text cursor-pointer"
            @click="
              (selectedNotesTemplateData = template) &&
                (notesTemplateForm = true)
            "
            v-text="'Update'"
          ></a>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- Notes Template Form -->
    <v-bottom-sheet v-model="notesTemplateForm" scrollable>
      <v-card tile>
        <vue-card-title
          :title="cardTitle"
          :subtitle="'Fill up the following form to action on notes template.'"
          :icon="$getIcon('mdiFileDocumentEdit')"
          closable
          @close="notesTemplateForm = false"
        >
        </vue-card-title>
        <v-divider></v-divider>
        <v-card-text class="form-scroll scrollbar">
          <notes-template-form
            v-if="selectedNotesTemplateData && notesTemplateForm"
            :action-data="selectedNotesTemplateData"
            @notesTemplateFormResponse="formSuccess"
          >
          </notes-template-form>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
    <!-- / Notes Template Form -->
  </v-card>
</template>

<script>
import PaginationMixin from "@/mixins/paginationSearchMixin";
import NotesTemplateForm from "@/components/crm/configuration/notes_template/forms/NotesTemplateForm";

export default {
  components: {
    NotesTemplateForm
  },
  mixins: [PaginationMixin],
  data() {
    return {
      // paginationMixin
      searchLabel: "Search for notes template...",
      // notes template form
      cardTitle: "",
      notesTemplateForm: false,
      selectedNotesTemplateData: {},
      organizationSlug: this.$store.state.shell.currentOrganizationId
    };
  },
  computed: {
    fetchAPI() {
      return (
        "/api/v1/crm/notes-templates/?organization__slug=" +
        this.organizationSlug
      );
    }
  },
  watch: {
    notesTemplateForm(newVal) {
      if (Object.keys(this.selectedNotesTemplateData).length > 0 && newVal) {
        this.cardTitle = "Update Notes Template";
      } else {
        this.selectedNotesTemplateData = {};
        this.cardTitle = "Create Notes Template";
      }
    }
  },
  methods: {
    formSuccess() {
      this.notesTemplateForm = false;
      this.fetchData();
    }
  }
};
</script>

<style scoped>
.notes {
  width: 100%;
  height: 250px;
}
.scrollbar-sm {
  background-color: #FFF59D;
  max-height: 280px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.scrollbar-sm::-webkit-scrollbar {
  width: 4px;
  background-color: #f5f5f5;
}
.scrollbar-sm::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #d3d3d3;
}
</style>
